import { HttpHeaders } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { TokenService } from 'src/app/shared/service/token.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-text-contents',
  templateUrl: './text-contents.component.html',
  styleUrls: ['./text-contents.component.scss']
})
export class TextContentsComponent implements OnInit {

  public menus = [];
  public selected = [];
  TextContents;
  isLoading;
  isDeleting;
  DeletingItem;

  constructor(private router: Router, private http: HttpClient, private toastr: ToastrService, private modalService: NgbModal,private TokenService: TokenService) {
    const a = JSON.parse(this.TokenService.getUser().Authority);
    if (!a['TextContents']) {
      router.navigateByUrl('/');
    }
  }


  ngOnInit() {
    this.GetTextContentsList();
  }

  GetTextContentsList() {
    this.http.get<any>(environment.url + 'Policies/GetPoliciesPages').subscribe(data => {
      this.TextContents = data.Data;
      this.TextContents.sort((a, b) => {
        if (a['LanguageCode'] != null && b['LanguageCode'] != null) {
          if (a['LanguageCode'].toLowerCase() > b['LanguageCode'].toLowerCase()) {
            return -1;
          }
          if (b['LanguageCode'].toLowerCase() > a['LanguageCode'].toLowerCase()) {
            return 1;
          }
        }
        else {
          return 1;
        }
        return 0;
      });
      this.isLoading = true;
    });
  }
  DeleteTextContent() {
    this.isDeleting = true;
    var body = { Ref: this.DeletingItem };
    this.http.post<any>(environment.url + 'Policies/DeletePolicies', body).subscribe(data => {
      this.isDeleting = false;
      this.DeletingItem = "";
      if (data.Success == true) {
        this.GetTextContentsList();
        this.modalService.dismissAll();
        this.toastr.success("Metin İçeriği Sayfası Silindi", '', {
          timeOut: 3000,
        });
      }
      else {
        this.toastr.error("Metin İçeriği Sayfası Silinemedi", 'Hata !', {
          timeOut: 3000,
        });
      }
    });
  }
  gotoPageEdit(item: any) {
    const navigatioExtra: NavigationExtras = {
      queryParams: { id: item }
    }
    this.router.navigate(['/home/cms/edit-page'], navigatioExtra);
  }
  DeleteTextContentModal(file,ref) {
    this.DeletingItem = ref;
    this.modalService.open(file, { centered: true });
  }
  CloseDeleteModalClose(){
    this.modalService.dismissAll();
    this.DeletingItem = "";
  }
}
